import crud from "./crud";
import crud_service from "@/services/crud";
import { isNone } from "@/functions";

// Enedis PADT injection curves (5-minute readings), read only
const path = "enedis_injection";
const struct = { time: null, value: null };
const generic = crud(path, struct);

const state = {
  ...generic.state,
  installations: [],
};

const getters = {
  ...generic.getters,
  installations: (state) => state.installations,
};

const mutations = {
  ...generic.mutations,
  setInstallations(state, items) {
    state.installations = items;
  },
};

function periodPayload({ start, end, producer_ids, direction } = {}) {
  const payload = {};
  if (!isNone(start)) payload["start"] = start;
  if (!isNone(end)) payload["end"] = end;
  if (!isNone(producer_ids) && producer_ids.length) payload["producer_id[]"] = producer_ids;
  if (!isNone(direction)) payload["direction"] = direction;
  return payload;
}

const actions = {
  ...generic.actions,

  // PADT installations with their last reading per direction
  getInstallations({ commit }, { producer_ids } = {}) {
    return crud_service.fetch(`${path}/installations`, periodPayload({ producer_ids })).then((items) => {
      commit("setInstallations", items);
      return items;
    });
  },

  // Monthly meter index: the Soregies production per park
  getSoregiesIndex(_, options) {
    return crud_service.fetch(`${path}/soregies_index`, periodPayload(options), { timeout: 60000 });
  },

  // Monthly sums per installation and direction (start inclusive, end exclusive, ISO dates)
  getSummary(_, options) {
    return crud_service.fetch(`${path}/summary`, periodPayload(options), { timeout: 60000 });
  },

  // EDF OA: monthly production energy clipped at each PDL's Pmax
  getOaSummary(_, options) {
    return crud_service.fetch(`${path}/oa_summary`, periodPayload(options), { timeout: 60000 });
  },

  // Monthly profile: fixed-price share (80 % of the profile) and spot share per PDL
  getProfileSummary(_, options) {
    const payload = periodPayload(options);
    if (!isNone(options?.share)) payload["share"] = options.share;
    return crud_service.fetch(`${path}/profile_summary`, payload, { timeout: 60000 });
  },

  // Set the profile (MWh) of one producer for one calendar month (1..12)
  setProfile(_, { producer_id, month, energy_mwh }) {
    return crud_service.post(`${path}/profiles`, { producer_id, month, energy_mwh });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
